const transformEntry = (puz, entry, direction, x, y) => {
  const clue = entry.clue;
  const answer = entry.cells
    .map((i) => String.fromCharCode(puz.solution[i]))
    .join("");

  return {
    clue,
    answer,
    direction,
    x,
    y,
  };
};

/**
 * Transform a .puz file to a format understandable to
 * svelte-crossword component
 */
const transformPuzFile = (puz) => {
  const output = [];
  const grid = puz.grid;
  for (let [y, row] of grid.entries()) {
    for (let [x, cell] of row.entries()) {
      if (cell.isStart) {
        if (cell.across.clue) {
          output.push(transformEntry(puz, cell.across, "across", x, y));
        }

        if (cell.down.clue) {
          output.push(transformEntry(puz, cell.down, "down", x, y));
        }
      }
    }
  }

  return output;
};

export default transformPuzFile;
